import { apiSlice } from "../api/apiSlice";

export const assignmentMarksApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAssignmentMarks: builder.query({
			query: () => "/assignmentMark",
		}),
		addAssignmentMark: builder.mutation({
			query: ({ data }) => {
				const modifiedData = { ...data, status: "pending" };
				return {
					url: "/assignmentMark",
					method: "POST",
					body: modifiedData,
				};
			},
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				try {
					const assignment = await queryFulfilled;
					if (assignment?.data?.id) {
						// update tasks cache pessimistically start
						dispatch(
							apiSlice.util.updateQueryData(
								"getAssignmentMarks",
								undefined,
								(draft) => {
									// console.log(JSON.parse(JSON.stringify(draft)));
									draft.push(assignment.data)
								}
							)
						);
						// update tasks cache pessimistically end
					}
				} catch (err) { }
			},
		}),
		editAssignmentMark: builder.mutation({
			query: ({ id, data }) => ({
				url: `/assignmentMark/${id}`,
				method: "PATCH",
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				// optimistic cache update start
				const pathResult = dispatch(
					apiSlice.util.updateQueryData(
						"getAssignmentMarks",
						undefined,
						(draft) => {
							const draftAssignmentMark = draft.find((mark) => mark.id == arg.id);
							// draftAssignmentMark.student_id = arg.data.student_id;
							// draftAssignmentMark.student_name = arg.data.student_name;
							// draftAssignmentMark.assignment_id = arg.data.assignment_id;
							// draftAssignmentMark.title = arg.data.title;
							// draftAssignmentMark.totalMark = arg.data.totalMark;
							// draftAssignmentMark.repo_link = arg.data.repo_link;
							// draftAssignmentMark.createdAt = arg.data.createdAt;
							draftAssignmentMark.mark = arg.data.mark;
							draftAssignmentMark.status = arg.data.status;
						}
					)
				);
				// optimistic cache update end

				try {
					await queryFulfilled;
				} catch (err) {
					pathResult.undo();
				}
			},
		})
	}),
});

export const {
	useGetAssignmentMarksQuery,
	useAddAssignmentMarkMutation,
	useEditAssignmentMarkMutation
} = assignmentMarksApi;
